import { styled } from '../../../config'
import { IconButton } from '../../IconButton'

const StyledIconButton = styled(IconButton, {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  height: '28px',
  width: '28px',
  variants: {
    left: {
      true: {
        left: '8px'
      }
    },
    right: {
      true: {
        right: '8px'
      }
    },
    round: {
      true: {
        borderRadius: '$round'
      }
    },
    dark: {
      true: {
        borderWidth: '2px',
        borderColor: '$white',
        borderStyle: 'solid',
        background: 'none',
        '> svg': {
          color: '$white'
        }
      }
    }
  }
})

export const StepperPrimitive = {
  IconButton: StyledIconButton
}
